import React from 'react';
import { ClockIcon } from 'lucide-react';
import { formatDistanceToNowStrict, format } from 'date-fns';
interface LastAssignedProps {
  timestamp: string | null;
}
export function LastAssigned({
  timestamp
}: LastAssignedProps) {
  if (!timestamp) {
    return <div className="flex flex-col" data-id="element-1" data-mp="3nmod5n4l3ge9">
        <span className="text-sm font-medium text-slate-400" data-id="element-2" data-mp="3jk01z8sedxe4">
          Not yet today
        </span>
        <span className="text-xs text-slate-300" data-id="element-3" data-mp="3ekf2mx9bfn0v">Next in rotation</span>
      </div>;
  }
  const date = new Date(timestamp);
  const rel = formatDistanceToNowStrict(date, {
    addSuffix: true
  });
  return <div className="flex items-center gap-2" data-id="element-4" data-mp="34vdmn72rt5mw">
      <ClockIcon className="h-3.5 w-3.5 text-slate-400" aria-hidden="true" data-id="element-5" data-mp="34rzknzy0qyfz" />
      <div className="flex flex-col leading-tight" data-id="element-6" data-mp="2zx2ed0s4j36s">
        <span className="text-sm font-medium text-slate-800" data-id="element-7" data-mp="2vu5oqq4626tc">{rel}</span>
        <span className="text-xs text-slate-400" data-id="element-8" data-mp="2vvgxl4cgy4rb">
          {format(date, 'MMM d, h:mm a')}
        </span>
      </div>
    </div>;
}